import PropTypes from "prop-types";
import { Box, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CollectionSelect } from "./collection-select";

export const FavouriteForm = ({
  favouriteName,
  onNameChange,
  selectedCollection,
  onCollectionChange,
  userCollections,
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ px: 3, py: 3 }}>
      <Stack spacing={2.5}>
        <TextField
          label={t("favourites.name")}
          fullWidth
          value={favouriteName}
          onChange={(e) => onNameChange(e.target.value)}
          size="small"
          autoFocus
        />
        <CollectionSelect
          value={selectedCollection}
          onChange={onCollectionChange}
          collections={userCollections}
        />
      </Stack>
    </Box>
  );
};

FavouriteForm.propTypes = {
  favouriteName: PropTypes.string,
  onNameChange: PropTypes.func.isRequired,
  selectedCollection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCollectionChange: PropTypes.func.isRequired,
  userCollections: PropTypes.array.isRequired,
};
